module.exports = __webpack_public_path__ + "img/verify-id.13d6409c.jpg";